<template lang="pug">
.theme-wrapper(:class="{ shown: !hide && engageTheme }")
  global-events(@keyup.esc="close")
  .theme(v-if="themesMetadata", :class="{ nudge: isNudged }")
    .close(@click="close") &times;
    //-.prev-next(v-if="themes && themes.length && Object.keys(engagePubContext || {}).length")
    //-  global-events(@keyup.stop.prevent.capture.left="engageTheme = prev",
    //-                @keyup.stop.prevent.capture.right="engageTheme = next",
    //-                @keyup.stop.prevent.capture.space="engageTheme = next",
    //-                @keyup.stop.prevent.capture.esc="close")
    //-  .prev(@click="engageTheme = prev", :title="prev && `switch to ${ (themeFomKey(prev) || {}).title }` || ''", v-lazy:background-image="prev && (themeFomKey(prev) || {}).image")
    //-  .current(v-lazy:background-image="theme && theme.image")
    //-  .next(@click="engageTheme = next", :title="next && `switch to ${ (themeFomKey(next) || {}).title }` || ''", v-lazy:background-image="next && (themeFomKey(next) || {}).image")
    .videos-section
      .title {{ { o: 'opportunity ', r: 'risk '}[spotlightCategory] || '' }}videos
      .videos(:class="{ collapsed: false }")
        .info(v-if="theme", :class="{ open: spotlightSettingsOpen }")
          .bg(v-lazy:background-image="theme.image")
          .bg(v-lazy:background-image="theme.image")
            .hamburger(@click="spotlightSettingsOpen = true")
              .line
          .backface
            .title spotlight settings
            .rows
              .a
                .categories
                  .trending(@click="spotlightCategory = null",
                        :class="{ on: !spotlightCategory }") trending
                  .opportunity(@click="spotlightCategory = 'o'",
                        :class="{ on: spotlightCategory === 'o' }") opportunity
                  .risk(@click="spotlightCategory = 'r'",
                        :class="{ on: spotlightCategory === 'r' }") risk
                    .box
              //.b b
              //.c c
          .under
            .title spotlight settings
            .close(@click="spotlightSettingsOpen = false") &times;
            .rows
              .a
                .categories
                  .trending(@click="spotlightCategory = null",
                            :class="{ on: !spotlightCategory }") trending
                  .opportunity(@click="spotlightCategory = 'o'",
                               :class="{ on: spotlightCategory === 'o' }") opportunity
                  .risk(@click="spotlightCategory = 'r'",
                        :class="{ on: spotlightCategory === 'r' }") risk
                    .box
              //.b b
              //.c c
          .title {{ theme.title }}
        .no-videos(v-if="!videos") no {{ !spotlightSource && spotlightInfo && spotlightInfo.n + ' ' || '' }}videos
        .video(v-for="(video, index) in videos || []", @click.stop.prevent="playVid(video)") {{ video.id || 77 }}
          .bg(v-lazy:background-image="`https://i.ytimg.com/vi/${ video.id }/mqdefault.jpg`")
            .bap
    .tweets-section(:class="{ shown: !engageTweetsCollapsed, hide: !spotlightSource }",
                    :title="engageTweetsCollapsed && 'show tweets' || ''"
                    @click.self="engageTweetsCollapsed = false")
      .title tweets
      .opener(:title="`${ engageTweetsCollapsed && 'show' || 'hide' } tweets`", @click="engageTweetsCollapsed = !engageTweetsCollapsed")
      masonry.twts(:cols="5", :gutter="16")
        //tweet.twt(v-for="id in ['1482152510584463364', '1482148274224123908', '1482143802064347136', '1482138024494383109', '1482136099602546689', '1482126318607212565', '1482123166587752448', '1482112024888983553', '1482110371200647170', '1482110241894449157', '1482100451583700997', '1482092539943473154', '1482090225186885636', '1482083695582449669', '1482083244669648898', '1482076942081921033', '1482070406420959234', '1482068235860201473', '1482067157735383044', '1482063556375977989', '1482059574567964674', '1482052130966065155', '1482051657714307088', '1482046615364022273', '1482045369995468809', '1482044876384526341', '1482044824618418179', '1482041732850241543', '1482041319534911488', '1482038384881246210']",
        tweet.twt(v-for="{ id } in tweets",
              :id="id",
              :key="id"
              :options="{ cards: 'visible', conversation: 'none' }")
      //-tweet(v-for="id in ['1482152510584463364']",
      //-      :tweet-id="id",
      //-      :key="id",
      //-      cards="visible",
      //-      conversation="all",
      //-      lang="en",
      //-      theme="light",
      //-      align="left",
      //-      :width="400",
      //-      :dnt="false")
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed } from '@/helpers';
import { Tweet } from 'vue-tweet-embed';
let closeTimer;
export default {
  name: 'theme',
  //emits: ['openReportCard'], //vue3?
  data() {
    return { hide: false, nudge: false };
  },
  watch: {
    engageTheme(newValue) {
      if (newValue) {
        const { fetchSpotlightVideos, fetchSpotlightTweets } = this;
        fetchSpotlightVideos(newValue);
        fetchSpotlightTweets(newValue);
        //https://dsgt1uxjkh3a.cloudfront.net/api/QueryTweets?ath=Business%20themes&dm=Investments&c=31
      }
    },
    spotlightCategory() {
      const { engageTheme, fetchSpotlightVideos, fetchSpotlightTweets } = this;
      fetchSpotlightVideos(engageTheme);
      fetchSpotlightTweets(engageTheme);
    },
    spotlightSource() {
      const { engageTheme, fetchSpotlightVideos, fetchSpotlightTweets } = this;
      fetchSpotlightVideos(engageTheme);
      fetchSpotlightTweets(engageTheme);
    }
  },
  computed: {
    ...mapGetters([
      'selectedWatchlistThemes',
      'analytics',
      'topParentThemes',
      'watchlistShown',
      'watchlistThemesShown',
      'watchlistThemesForPickerMax',
      'filteredWatchlistThemes',
      'roboReportShown',
      'publishers',
      'watchlistPublishers',
      'refPubInfo',
      'engage',
      'engageBap',
      'engageFilteredPublishers',
      'engageStockOverview',
      'spotlightVideos',
      'spotlightTweets',
      'spotlightSource',
      'spotlightInfo'
    ]),
    ...vuexComputed(
      'engagePub',
      'selectedWatchlistPublishers',
      'watchlistThemesParentFilter',
      'watchlistThemesRefPub',
      'watchlistThemesRefPubSentiment',
      'watchlistThemesHoverRefPubSentiment',
      'watchlistThemesRefPubSwitcher',
      'watchlistThemesRefPubSwitcherFilter',
      'watchlistThemesRefPubSort',
      'watchlistThemesAndOr',
      'refPubInfoShown',
      'refPubInfoNudge',
      'engageReportCardShown',
      'engagePubContext',
      'currentVideo',
      'collapsed',
      'playlist',
      'engageTheme',
      'engageVideosOnly',
      'engageTweetsCollapsed',
      'spotlightSettingsOpen',
      'spotlightCategory'
    ),
    isNudged() {
      const { nudge, currentVideo, collapsed } = this;
      return nudge || (currentVideo && !collapsed);
    },
    themesMetadata() {
      return this.engage?.themesMetadata;
    },
    themes() {
      const { themesMetadata, engageVideosOnly, hasVideos } = this;
      // console.log('themes', Object.values(this.themesMetadata?.themes || {})?.sort((a, b) => (b.cr || 0) - (a.cr || 0)));
      return Object.entries(this.themesMetadata?.themes || {})
        ?.sort((a, b) => (b[1].cr || 0) - (a[1].cr || 0))
        ?.filter(([k]) => !engageVideosOnly || hasVideos(k));
    },
    theme() {
      const { themesMetadata, engageTheme } = this;
      console.log('computed theme', themesMetadata?.themes?.[engageTheme]);
      return themesMetadata?.themes?.[engageTheme];
    },
    earnings() {
      const { engageStockOverview } = this;
      return engageStockOverview?.earningsCalendar;
    },
    videos() {
      const {
        // engage: { scenes, videos },
        engage: { domains = [] },
        engageTheme,
        spotlightVideos,
        spotlightCategory,
        spotlightSource
      } = this;
      //console.log('theme videos getter', scenes, videos, engageTheme);
      return spotlightVideos[[engageTheme, domains.join('|')].join('__') + (spotlightCategory && `__${ spotlightCategory }` || '') + (spotlightSource && `__${ spotlightSource }` || '')]?.videos;
      //return scenes?.[engageTheme]?.videoIds?.split('|')?.map(k => videos[k]);
    },
    tweets() {
      const {
        // engage: { scenes, videos },
        engage: { domains = [] },
        engageTheme,
        spotlightTweets,
        spotlightCategory,
        spotlightSource
      } = this;
      //console.log('theme tweets getter', scenes, tweets, engageTheme);
      return spotlightTweets[[engageTheme, domains.join('|')].join('__') + (spotlightCategory && `__${ spotlightCategory }` || '') + (spotlightSource && `__${ spotlightSource }` || '')]?.tweets;
    },
    hasReportCards() {
      const {
        engage: { scenes },
        engagePub
      } = this;
      //console.log('hasReportCards', engagePub, scenes?.[engagePub]?.reportCards?.length);
      return scenes?.[engagePub]?.reportCards?.length;
    },
    prev() {
      const { themes, currentIndex } = this;
      console.log('prev', currentIndex, themes?.[currentIndex - 1], themes);
      return themes?.[currentIndex - 1]?.[0];
    },
    next() {
      const { themes, currentIndex } = this;
      // return Object.keys(themes)[currentIndex + 1];
      return themes?.[currentIndex + 1]?.[0];
    },
    currentIndex() {
      const { themes, engageTheme } = this;
      return themes.findIndex(([k, v]) => k === engageTheme);
    },
    ratings() {
      const { engageStockOverview: eso = {} } = this;
      return {
        sell: eso.analystRatingsStrongSellPercentage || 0,
        underperform: eso.analystRatingsSellPercentage || 0,
        hold: eso.analystRatingsHoldPercentage || 0,
        outperform: eso.analystRatingsBuyPercentage || 0,
        buy: eso.analystRatingsStrongBuyPercentage || 0
      };
    },
    watchlistUrl() {
      const { engageBap = {} } = this;
      const { reportCard: rc, n } = engageBap;
      return rc && `/?wl=${ rc.watchList };rc=${ n }`;
    },
    childThemes() {
      const { filteredThemes, watchlistThemesParentFilter: wtpf, themes } = this;
      let r = [];
      // console.log('childThemes', wtpf);
      if (wtpf && filteredThemes) {
        // console.log('childThemes', wtpf, filteredThemes);
        //const parentThemes = filteredThemes?.filter(({ cth }) => cth);
        // if (parentThemes.length === 1) {
        if (themes && wtpf && themes[wtpf]) {
          const filteredMap = filteredThemes.reduce((map, { n }) => {
            map[n] = true;
            return map;
          }, {});
          // console.log('childThemes', wtpf, parentThemes[0].cth, filteredMap);
          // console.log('childThemes', wtpf, themes[wtpf].cth, filteredMap);
          //r = parentThemes[0].cth
          r = themes[wtpf].cth
            .filter(({ n }) => filteredMap[n])
            .map(({ n, cr }) => {
              return { ...themes[n], cr };
            });
        }
      }
      // console.log('childThemes:', r);
      return r;
    },
    itemsPerPage() {
      const max = 42;
      return ((this.importantChildThemes || []).length === max && max) || max - 1;
    },
    importantChildThemes() {
      const { childThemes, watchlistThemesParentFilter: filter, themes } = this;

      const r = childThemes.filter(({ cr }) => cr >= 50).sort((a, b) => b.cr - a.cr);
      // console.log('crs', childThemes, r.map(({ cr }) => cr));
      // const r = childThemes.filter(th => dynamicCr(th) >= 50).sort((a, b) => dynamicCr(b) - dynamicCr(a));
      // console.log('ict', childThemes, /*themes[filter].cth,*/ childThemes[3].n, childThemes[3] && dynamicCr(childThemes[3]), r);
      return r;
      //return childThemes.filter(th => dynamicCr(th) >= 50).sort((a, b) => dynamicCr(b) - dynamicCr(a));
      function dynamicCr(theme) {
        let r = theme.cr;
        //console.log('dynamicCr', themes);
        if (filter && themes) {
          if (theme.cth) {
            r = 100;
          } else {
            //const { cth } = themes[filter] || {};
            if (theme.index > -1) {
              r = childThemes[theme.index]?.cr || r;
              // r = cth[theme.index]?.cr || r;
            }
            // const { cth } = themes[filter] || {};
            // if (cth && theme.index > -1) {
            //   r = cth.find(({ n }) => n === theme.n)?.cr || r;
            //   // r = cth[theme.index]?.cr || r;
            // }
          }
        }
        return r;
      }
    },
    arielViewThemes() {
      const {
        importantChildThemes: ict,
        arielOffset,
        itemsPerPage,
        watchlistThemesRefPubSentiment: sentiment,
        watchlistThemesHoverRefPubSentiment: hoverSentiment,
        refPub,
        morphedPS
      } = this;
      let r = ict;
      const s = hoverSentiment || sentiment;
      if (s) {
        const cprToRating = cpr => {
          /*let logValue =
            (cpr <= 25 && 'very poorly') ||
            (cpr <= 50 && 'poorly') ||
            (cpr >= 75 && 'very well') ||
            (cpr >= 50 && 'well');
          console.log('cprToRating', cpr, logValue);*/
          return (
            (cpr <= 25 && 'very poorly') ||
            (cpr <= 50 && 'poorly') ||
            (cpr >= 75 && 'very well') ||
            (cpr >= 50 && 'well')
          );
        };
        // const was = [...r];
        r = r.filter(({ ps }) => {
          // console.log('avt filtering', morphedPS(ps), morphedPS(ps).find(({ n }) => n === refPub.n), refPub);
          return cprToRating(morphedPS(ps).find(({ n }) => n === (refPub?.n || '-1'))?.cpr) === s;
        });
        //r = r.filter(({ ps }) => cprToRating(morphedPS(ps)[refPub.n].cpr) === s);
        // console.log('avt', refPub, cprToRating(55), s, was, r);
      }
      return r.filter((item, index) => arielOffset <= index && index < arielOffset + itemsPerPage);
    },
    refPub() {
      const { watchlistThemesRefPub, publishers, watchlistPublishers: wps } = this;
      return publishers[watchlistThemesRefPub] || { id: watchlistThemesRefPub, n: wps[watchlistThemesRefPub].n };
    },
    refPubInfoStyle() {
      const { refPubInfoNudge: { top, left } } = this;
      return { transform: `translate3d(${ left }px, ${ top }px, 0)` };
    },
    sentiment() {
      return this.watchlistThemesRefPubSentiment;
    },
    filteredThemes() {
      const { filteredWatchlistThemes, morphedPS, sentiment, watchlistThemesRefPub: refPub } = this;
      //console.log('filteredWatchlistThemes', filteredWatchlistThemes);
      // console.log(
      //   'ftt',
      //   (sentiment &&
      //     refPub &&
      //     filteredWatchlistThemes.filter(({ ps, n }) => show(morphedPS(ps).find(({ key }) => key === refPub), n))) ||
      //     filteredWatchlistThemes
      // );
      return (
        (sentiment &&
          refPub &&
          filteredWatchlistThemes.filter(({ ps, n }) => show(morphedPS(ps).find(({ key }) => key === refPub), n))) ||
        filteredWatchlistThemes
      );
      function show(ps, n) {
        const { cpr = 0 } = ps || {};
        //console.log('show ps', ps, cpr, sentiment, refPub, n);
        // console.log('show ps', cpr);
        return (
          ps &&
          {
            'very poorly'() {
              return cpr <= 25;
            },
            poorly() {
              // return cpr <= 50;
              return 25 < cpr && cpr <= 50;
            },
            well() {
              return 50 < cpr && cpr < 75;
            },
            'very well'() {
              return cpr >= 75;
            }
          }[sentiment]()
        );
      }
    },
    parentThemes() {
      const { topParentThemes, themes } = this;
      // console.log('computed themes', topParentThemes, (selectedVis === 'selectedThemes' && Object.keys(selectedThemes) || topParentThemes)
      //   .filter(n => themes[n])
      //   .map(n => themes[n]));
      return topParentThemes.map(([n]) => n)
        .filter(n => themes[n])
        .map(n => themes[n]);
    },
    sortedFilteredRefPubs() {
      const { filteredRefPubs, watchlistThemesRefPubSort: sort, filteredThemes: themes, morphedPS, watchlistThemesParentFilter: parentTheme } = this;
      let r = Object.entries(filteredRefPubs).map(([key, value]) => ({ key, ...value }));
      if (sort) {
        const t = themes.map(({ ps }) => morphedPS(ps));
        if (parentTheme) {
          const { ps } = themes.find(({ n }) => n === parentTheme) || {};
          // console.log('parent theme', parentTheme);
          const mps = morphedPS(ps);
          // console.log('morphed', mps);
          r.forEach(pub => {
            pub.sortWeight = (mps.find(({ key }) => key === pub.key) || { cr: 0 }).cr;
          });
        } else {
          const tally = t.reduce((tally, ps) => {
            ps.forEach(({ key, cr }) => {
              tally[key] = tally[key] || 0;
              tally[key] += cr;
            });
            return tally;
          }, {});
          r.forEach(pub => {
            pub.sortWeight = tally[pub.key];
          });
        }
        r.sort((a, b) => {
          let r = a.sortWeight - b.sortWeight;
          return (sort === 'ascending' && r) || b.sortWeight - a.sortWeight;
        });
      }
      // console.log('sortedFilteredRefPubs', r);
      return r;
    },
    filteredRefPubs() {
      const { publishers, watchlistThemesRefPubSwitcherFilter } = this;
      return Object.entries(publishers)
        .filter(([_, { n, s }]) => testPub(n, s))
        .reduce((map, [key, pub]) => {
          map[key] = pub;
          return map;
        }, {});
      function testPub(n, s) {
        const searchText = `${ n }|${ (s || []).join('|') }`;
        return !watchlistThemesRefPubSwitcherFilter || watchlistThemesRefPubSwitcherFilter.split(/\s+/).every(testWord);
        function testWord(word) {
          const tester = new RegExp(escapeRegExp(word), 'i');
          return tester.test(searchText);
        }
      }
      function escapeRegExpAndBound(s) {
        return `\\b${ escapeRegExp(s) }\\b`; // $& means the whole matched string
      }
      function escapeRegExp(s) {
        return `${ s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }`; // $& means the whole matched string
      }
    },
    spotlightInfo() {
      return Object.values(this.engage.spotlightInfo.sourcesTable || {}).find(({ id }) => id !== 'weaveai');
    }
  },
  methods: {
    ...mapActions([
      'toggleSelectedWatchlistTheme',
      'toggleSelectedWatchlistPublisher',
      'loadRoboReport',
      'addEngageSelectedPublisher',
      'videoClicked',
      'fetchSpotlightVideos',
      'fetchSpotlightTweets'
    ]),
    hasVideos(theme) {
      const { engage: { scenes } } = this;
      return !!scenes?.[theme]?.videoIds?.split('|');
    },
    themeFomKey(key) {
      console.log('themeFomKey', key, this.themesMetadata?.themes);
      return this.themesMetadata?.themes[key];
    },
    close() {
      clearTimeout(closeTimer);
      this.hide = true;
      closeTimer = setTimeout(() => {
        this.engageTheme = null;
        this.hide = false;
        this.nudge = false;
      }, 300);
    },
    perf(percent) {
      //todo: reanme this method
      let r = (percent >= 0 && 'pos-') || 'neg-';
      const abs = Math.abs(percent)
      if (abs > 50) {
        r += 'large';
      } else if (abs > 10) {
        r += 'mid';
      } else {
        r += 'small';
      }
      return r;
    },
    playVid(video) {
      const { videoClicked, theme: { title } } = this;
      videoClicked(['theme viewer', title, video]);
      this.currentVideo = video;
      this.collapsed = false;
      this.playlist = [ ...this.videos ];
    },
    downTitle(e) {
      const { $refs: { refPubInfo }, refPubInfoNudge: { top, left }, $el } = this;
      const { clientX, clientY } = e;
      const nudge = (left, top) => (this.refPubInfoNudge = { left, top });
      //style.transform = `translate3d(1px, 1px, 0)`;
      const handlers = {
        move(e) {
          console.log('move', left + clientX - e.clientX);
          nudge(left + e.clientX - clientX, top + e.clientY - clientY);
        },
        up() {
          console.log('up1', $el || 'huh?');
          $el.removeEventListener('mousemove', handlers.move);
          $el.removeEventListener('mouseup', handlers.up);
          console.log('up2');
        }
      };
      $el.addEventListener('mousemove', handlers.move);
      $el.addEventListener('mouseup', handlers.up);
    },
    setSentiment(value, toggle) {
      const { $store: { state: { watchlistThemesRefPubSentiment: wtrps } } } = this;
      // console.log('setSentiment', value, toggle, wtrps !== value, (!toggle || wtrps !== value) && value || null);
      this.watchlistThemesRefPubSentiment = (!toggle || wtrps !== value) && value || null;
    },
    morphedPS(ps) {
      //const pt = this.analytics.thd.pt;
      const { analytics: { thd: { pt } }, publishers, watchlistPublishers: wps } = this;
      //console.log('morphedPS index', Object.entries(ps));
      return Object.entries(ps || {})
        .reduce((all, [i, v]) => {
          const key = pt[i];
          all.push({ ...(publishers[key] || (wps[key] && { id: key, n: wps[key].n }) || {}), key, ...(v || {}) });
          return all;
        }, [])
        .sort((a, b) => a.cr - b.cr);
    },
    weight(c) {
      return (c / this.watchlistThemesForPickerMax).toPrecision(2);
    }
  },
  components: { tweet: Tweet }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.theme-wrapper {
  pointer-events: none;
  //position: sticky;
  position: fixed;
  left: 1rem;
  top: 5rem;
  height: 1px;
  transform: translate3d(-150vw, 0, 0);
  transition: transform 600ms ease-in-out;
  z-index: 17000;
  &.shown {
    transform: translate3d(0, 0, 1px);// fix for safari
  }
  .theme {
    position: relative;
    cursor: default;
    pointer-events: all;
    user-select: none;
    width: 50rem;
    //min-height: 40rem;
    height: 55rem;
    max-height: 85vh;
    background-color: white;
    border: 2px solid rgba($brn, 0.5);
    box-shadow: 1px 1px 5px rgba($brn, 0.25);
    box-sizing: border-box;
    border-radius: 0.5rem;
    padding: 1rem;
    text-align: left;
    //overflow: hidden;
    color: $brn;
    transition: transform 250ms ease-in-out;
    &.nudge {
      transform: translate3d(35.5rem, 0, 0);
    }
    & > .close {
      cursor: pointer;
      position: absolute;
      top: -0.25rem;
      right: 0.5rem;
      color: rgba($brn, 0.5);
      font-size: 1.75rem;
      transition: color 250ms ease-in-out;
      &:hover {
        color: black;
      }
    }
    & > .tweets-section {
      position: absolute;
      top: -0.125rem;
      left: 100%;
      margin-left: 1rem;
      //bottom: 0;
      box-sizing: border-box;
      width: 87rem;
      padding: 4.35rem 2rem 2rem;
      padding-left: 5rem;
      border-radius: 0.75rem;
      border: 2px solid rgba($brn, 0.5);
      box-shadow: 1px 1px 5px rgba($brn, 0.25);
      background-color: white;
      transform: scale(0.65) translate3d(-91%, 0, 1px);
      transform-origin: top left;
      z-index: -1;
      height: 83.75rem;
      max-height: 131vh;
      overflow: visible;
      overflow-y: auto;
      transition: all 250ms ease-in-out;
      &.hide {
        opacity: 0;
        pointer-events: none;
        & * {
          pointer-events: none !important;
        }
        & > * > * {
          visibility: hidden;
        }
      }
      &.shown {
        transform: scale(0.65) translate3d(0, 0, 1px);
        & > .twts {
          opacity: 1;
          pointer-events: all;
        }
        & > .opener {
          transform: rotate(90deg) translate3d(-1rem, 83rem, 0);
        }
      }
      & > .twts {
        opacity: 0;
        pointer-events: none;
        transition: opacity 250ms ease-in-out;
      }
      .twt {
         //transition: transform 250ms ease-in-out 500ms;
        &:hover {
          //transform: scale(2.5);
        }
      }
      & > .title {
        pointer-events: none;
        position: absolute;
        top: 2rem;
        right: 2rem;
        font-family: 'Assistant', sans-serif;
        font-size: 2rem;
        font-weight: 200;
        color: $brn;
        text-transform: capitalize;
        //transform: translate3d(3.5rem, 0, 0);
      }
      .opener {
        cursor: pointer;
        position: absolute;
        top: 50%;
        right: -5rem;
        text-align: center;
        padding: 12px;
        margin-bottom: 6px;
        height: 30px;
        width: 200px;
        transform: rotate(-90deg) translate3d(0, -50%, 0);
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          height: 17.5%;
          width: 51%;
          background: rgba($brn, 0.75);
          transform: skew(0deg, 6deg);
        }
        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          height: 17.5%;
          width: 50%;
          background: rgba($brn, 0.75);
          transform: skew(0deg, -6deg);
        }
      }
    }
    & > .prev-next {
      cursor: pointer;
      position: absolute;
      z-index: 2;
      bottom: 0.25rem;
      right: 0.25rem;
      display: grid;
      grid-template-columns: repeat(3, 3rem);
      grid-column-gap: 0.125rem;
      height: 3.5rem;
      box-sizing: border-box;
      padding: 0.25rem;
      border: 1px solid rgba($brn, 0.5);
      border-radius: 0.25rem;
      background-color: white;
      & > * {
        background: white center no-repeat;
        background-size: cover;
        border-radius: 0.5rem;
      }
      & > .current {
        transform: scale(0.5);
        //transform-origin: ;
        opacity: 0.5;
        cursor: default;
      }
    }
    & > .title {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      //transform: translate3d(-50%, 0, 0);
      font-size: 4rem;
      text-align: center;
      background-color: orange;
      color: white;
      text-shadow: 0 0 2px black;
      font-weight: 700;
      font-family: Assistant, Roboto, sans-serif;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border-bottom: 2rem solid orange;
      box-sizing: border-box;
      & > .close {
        position: absolute;
        top: -0.5rem;
        right: 0.25rem;
        transform-origin: top right;
        transform: scale(0.5);
      }
    }
    & > .info {
      position: relative;
      width: 24.35rem;
      min-height: 24.35rem;
      & > .ticker-title {
        position: absolute;
        left: 8.75rem;
        top: 0.5rem;
        display: flex;
        font-size: 2.5rem;
        font-family: 'Assistant', sans-serif;
        & > .ticker {
          color: black;
          font-size: 4rem;
          margin-right: 2rem;
          position: relative;
          top: -1rem;
        }
        & > .title {
          font-size: 2.3rem;
          white-space: nowrap;
        }
        & > .dash {
          display: none;
          margin: 0 0.5rem;
        }
      }
      & > .meta {
        position: absolute;
        left: 9rem;
        top: 4rem;
        width: 29rem;
        height: 5rem;
        z-index: 5;
        //display: flex;
        //font-size: 2.5rem;
        font-family: 'Assistant', sans-serif;
        &::after {
          content: '';
          position: absolute;
          right: 0;
          top: 100%;
          width: 3rem;
          height: 4rem;
        }
        & > * {
          margin-right: 1rem;
          white-space: nowrap;
        }
        & > .talking-points {
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 20rem;
          text-transform: uppercase;
          font-size: 0.8rem;
          transition: all 250ms ease-in-out;
          &:hover {
            color: black;
          }
          &.hide {
            pointer-events: none;
            opacity: 0;
          }
        }
        & > .report-card-opener {
          cursor: pointer;
          position: absolute;
          top: 1.2rem;
          left: 20rem;
          text-transform: uppercase;
          font-size: 0.8rem;
        }
      }
      & > .bg {
        background: white center no-repeat;
        background-size: contain;
        position: absolute;
        top: 0.25rem;
        left: 0.25rem;
        width: 8rem;
        height: 8rem;
        z-index: 1;
        border-radius: 0.5rem;
        //border-top-left-radius: 0.5rem;
        //border-bottom-left-radius: 0.5rem;
      }
      & > .big-bg {
        pointer-events: none;
        background: white center no-repeat;
        background-size: contain;
        position: absolute;
        top: 0.25rem;
        left: 4rem;
        width: 24.35rem;
        height: 24.35rem;
        border-radius: 0.5rem;
        //z-index: -1;
        //opacity: 0.06125;
        opacity: 0.125;
        //border-top-left-radius: 0.5rem;
        //border-bottom-left-radius: 0.5rem;
      }
    }
    & > .videos-section {
      position: relative;
      //position: absolute;
      //top: 5rem;
      //right: 1.5rem;
      &:hover {
        z-index: 5;
      }
      &.hide {
        opacity: 0;
        pointer-events: none;
      }
      & > .title {
        pointer-events: none;
        font-family: 'Assistant', sans-serif;
        font-size: 1.5rem;
        font-weight: 200;
        color: $brn;
        text-transform: capitalize;
        text-align: center;
        //transform: translate3d(3.5rem, 0, 0);
      }
      .videos {
        //padding-left: 7rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        position: relative;
        display: grid;
        grid-template-columns: repeat(5, 9rem);
        grid-auto-rows: min-content;
        grid-gap: 0.5rem;
        overflow: hidden;
        overflow-y: auto;
        height: 51.65rem;
        max-height: 78.5vh;
        //max-height: 6.5rem;
        //background-color: #dadada;
        &:hover {
          //max-height: 32.75rem;
          //overflow: auto;
          //overflow-x: visible;
          & > .video {
            pointer-events: all !important;
            transform: none !important;
          }
        }
        &.collapsed {
          & > .video {
            //pointer-events: none;
            transition: transform 250ms ease-in-out;
            &:first-of-type {
              z-index: 1;
              box-shadow: 1px 1px 0.25rem black;
              transform: none !important;
            }
            &:last-of-type {
              margin-bottom: 4.25rem;
              box-shadow: none;
            }
          }
        }
        .info {
          position: relative;
          grid-column: 1 / span 2;
          grid-row: 1 / span 4;
          height: 23rem;
          perspective: 500rem;
          & > .title {
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            text-align: center;
            font-family: 'Assistant', sans-serif;
            font-size: 2rem;
            white-space: nowrap;
            color: $brn;
            font-weight: 200;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          &.open {
            & > .bg + .bg {
              transform: rotate3d(0, 1, 0, -180deg);
            }
            & > .backface {
              transform: rotate3d(0, 1, 0, 0);
            }
          }
          & > .bg {
            position: absolute;
            top: 0.125rem;
            left: 0.125rem;
            bottom: 2.5rem;
            right: 0.125rem;
            background: no-repeat center top;
            background-size: cover;
            border-radius: 0.5rem;
            &:first-of-type {
              clip-path: inset(0 50% 0 0);
            }
            & + .bg {
              z-index: 2;
              //opacity: 0.5;
              clip-path: inset(0 0 0 50%);
              transition: transform 250ms ease-in-out;
              backface-visibility: hidden;
              transform-style: preserve-3d;
              //background-image: none !important;
            }
            & > .hamburger {
              cursor: pointer;
              position: absolute;
              top: 0.5rem;
              right: 0.5rem;
              border-radius: 0.5rem;
              width: 3rem;
              height: 3rem;
              padding: 0.5rem;
              background-color: rgba($brn, 0.75);
              transform: scale(0.5);
              transform-origin: top right;
              transition: background-color 250ms ease-in-out;
              &:hover {
                background-color: $brn;
              }
              & > .line,
              & > .line::before,
              & > .line::after {
                display: block;
                content: '';
                background-color: white;
                height: 0.7rem;
                border-radius: 0.5rem;
                margin-bottom: 0.4rem;
              }
              & > .line::before {
                position: relative;
                top: 2.2rem;
              }
            }
          }
          //$backcolor: #fafafa;
          $backcolor: #fdfdfd;
          & > .backface,
          & > .under {
            position: absolute;
            top: 0.125rem;
            left: 0.125rem;
            bottom: 2.5rem;
            right: 0.125rem;
            border-radius: 0.5rem;
            transform-style: preserve-3d;
            transition: transform 250ms ease-in-out;
            font-size: 2rem;
            box-sizing: border-box;
            padding: 2rem;
            border: 1px solid rgba($brn, 0.25);
            background-color: $backcolor;
            & > .title {
              position: absolute;
              top: 0.75rem;
              left: 0;
              right: 0;
              text-align: center;
              font-family: 'Assistant', sans-serif;
              font-size: 1.2rem;
              font-weight: 200;
              text-transform: uppercase;
              white-space: nowrap;
            }
            & > .close {
              position: absolute;
              top: 0;
              right: 0.5rem;
              font-size: 2.5rem;
              padding-top: 0;
              padding-left: 0.5rem;
              opacity: 0.7;
              will-change: opacity;
              transition: opacity 250ms ease-in-out;
              &:hover {
                opacity: 1;
              }
            }
            & > .rows {
              position: absolute;
              top: 4.5rem;
              left: 1.5rem;
              right: 1.5rem;
              bottom: 0.5rem;
              display: grid;
              grid-template-rows: repeat(3, 3rem);
              .categories {
                margin-left: -1rem;
                margin-right: -1rem;
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                font-size: 0.7rem;
                font-weight: 400;
                box-sizing: border-box;
                & > * {
                  cursor: pointer;
                  position: relative;
                  padding: 0.5rem 0.25rem;
                  text-align: center;
                  text-transform: uppercase;
                }
                & > .trending.on + .opportunity + .risk {
                  .box {
                    transform: translate3d(-200%, 0, 0);
                  }
                }
                & > .opportunity.on + .risk {
                  .box {
                    transform: translate3d(-100%, 0, 0);
                  }
                }
                .box {
                  position: absolute;
                  top: 0;
                  left: 0;
                  bottom: 0;
                  right: 0;
                  box-sizing: border-box;
                  border-radius: 0.25rem;
                  border: 2px solid orange;
                  transition: transform 250ms ease-in-out;
                  z-index: 1;
                }
              }
            }
          }
          & > .backface {
            clip-path: inset(0 50% 0 0);
            //background-color: lightsteelblue;
            //padding: 2rem 50% 2rem 2rem;
            //color: white;
            transform: rotate3d(0, 1, 0, -180deg);
            backface-visibility: hidden;
            z-index: 1;
          }
          & > .under {
            //padding-left: 50%;
            z-index: -1;
          }
        }
        .no-videos {
          grid-column: 4 / span 3;
          position: relative;
          top: 2rem;
          font-family: 'Assistant', sans-serif;
          font-size: 1.2rem;
          white-space: nowrap;
          color: $brn;
          font-weight: 200;
        }
        .video {
          cursor: pointer;
          position: relative;
          width: 9rem;
          height: 5rem;
          border-radius: 0.5rem;
          margin: 0.25rem 0;
          box-sizing: border-box;
          border: 2px solid rgba($brn, 0.25);
          & > .bg {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            border-radius: 0.5rem;
            background: #ccc center no-repeat;
            background-size: contain;
            &:hover {
              & > .bap {
                opacity: 1;
              }
            }
            & > .bap {
              position: absolute;
              top: 25%;
              left: 27%;
              right: 27%;
              height: 50%;
              background: rgba(40, 40, 40, 0.25) no-repeat center
                url("data:image/svg+xml;charset%3Dutf8,%3Csvg height%3D'6.827in'  viewBox%3D'0 0 6.827 6.827' width%3D'6.827in' xmlns%3D'http://www.w3.org/2000/svg'%3E%3Cpath fill%3D'white' d%3D'M2.83373 4.08723c0.234571,-0.12152 0.468327,-0.242677 0.702075,-0.363862 0.229406,-0.118933 0.458823,-0.237913 0.689008,-0.357299 -0.255059,-0.133181 -0.508724,-0.265543 -0.762114,-0.397764 -0.209614,-0.109378 -0.419059,-0.218677 -0.628969,-0.328256l0 1.44718zm0.750823 -0.26928c-0.259551,0.134563 -0.51911,0.269091 -0.779783,0.404118l-0.0777087 0.040252 0 -0.0875433 0 -1.62249 0 -0.0877638 0.0779173 0.0406811c0.236012,0.123224 0.471343,0.246024 0.706886,0.368933 0.283362,0.147858 0.567059,0.295898 0.852677,0.445059l0.0905591 0.0472953 -0.0907677 0.0470787c-0.260673,0.135205 -0.520232,0.269819 -0.77978,0.404378z'/%3E%3Cpath fill%3D'white' d%3D'M5.83278 4.58511c-0.0327126,0.14115 -0.106701,0.263898 -0.20726,0.355248 -0.101142,0.091874 -0.229165,0.152126 -0.369209,0.16763 -0.305,0.0341142 -0.612587,0.0512874 -0.921185,0.0598937 -0.306618,0.00855118 -0.614535,0.00855118 -0.921929,0.00837402 -0.307256,0.000177165 -0.615177,0.000177165 -0.921839,-0.00837402 -0.308642,-0.0086063 -0.616319,-0.0257795 -0.921354,-0.0598937 -0.140071,-0.0155039 -0.268122,-0.0757756 -0.36922,-0.167677 -0.100508,-0.0913583 -0.174394,-0.214094 -0.206894,-0.355201 -0.0436378,-0.189098 -0.0654331,-0.386354 -0.0763071,-0.584752 -0.0109252,-0.199445 -0.0109291,-0.395992 -0.0109291,-0.586795 0,-0.191055 0.000279528,-0.387858 0.0114685,-0.587185 0.0111457,-0.198484 0.0332087,-0.395748 0.0768228,-0.584815 0.0323071,-0.141047 0.106157,-0.263748 0.206673,-0.35511 0.101157,-0.0919528 0.229335,-0.15226 0.369445,-0.167764 0.304996,-0.0341181 0.612673,-0.0512913 0.921315,-0.0599016 0.306665,-0.00855118 0.614587,-0.00855118 0.921799,-0.00837402 0.307256,-0.000177165 0.615197,-0.000177165 0.921823,0.00837402 0.308606,0.00861024 0.616193,0.0257835 0.921016,0.0599016 0.140244,0.0154961 0.268476,0.0757756 0.369728,0.167689 0.100626,0.0913504 0.174594,0.214075 0.207094,0.355185 0.0859488,0.37402 0.0859488,0.779492 0.0859409,1.16233l0.000208661 0 0 0.00967323 -0.000208661 0c1.5748e-005,0.192681 -7.48031e-005,0.391154 -0.0108425,0.586795 -0.0109134,0.19839 -0.0327126,0.395646 -0.0761575,0.584752zm-0.278929 0.2765c0.0849961,-0.0772126 0.147535,-0.180961 0.175181,-0.300248 0.0419449,-0.182579 0.0630433,-0.373945 0.0736535,-0.566839 0.0107638,-0.19563 0.0108543,-0.391161 0.0108425,-0.580961l-0.000208661 0 0 -0.00967323 0.000208661 0c3.93701e-006,-0.376594 7.87402e-006,-0.775457 -0.083437,-1.13858 -0.0274685,-0.119264 -0.0899803,-0.222992 -0.175016,-0.300185 -0.0849213,-0.0770866 -0.19235,-0.12763 -0.309728,-0.140602 -0.30328,-0.0339488 -0.607673,-0.0509882 -0.91226,-0.0594843 -0.306567,-0.00854724 -0.613094,-0.00854724 -0.918909,-0.00837402 -0.305772,-0.000173228 -0.61228,-0.000173228 -0.918886,0.00837402 -0.304618,0.00849606 -0.609102,0.0255394 -0.912559,0.0594843 -0.117224,0.0129724 -0.224587,0.0635433 -0.309445,0.140677 -0.0848898,0.0771614 -0.14728,0.180858 -0.174594,0.30011 -0.0421299,0.182626 -0.0634843,0.373984 -0.0743189,0.566902 -0.0107835,0.192075 -0.0110512,0.389496 -0.0110512,0.58135 0,0.191677 0,0.38913 0.0105118,0.580961 0.0105709,0.192882 0.0316654,0.384244 0.0738031,0.566839 0.0274724,0.119291 0.0899055,0.22302 0.174815,0.300201 0.0847992,0.0770866 0.192043,0.127618 0.30922,0.140591 0.303492,0.0339449 0.607976,0.0509843 0.912598,0.0594764 0.306602,0.00854724 0.61311,0.00854724 0.918925,0.00837402 0.305953,0.000173228 0.612457,0.000173228 0.919016,-0.00837402 0.304579,-0.00849213 0.608972,-0.0255354 0.912429,-0.0594764 0.117157,-0.0129724 0.224382,-0.0634882 0.309209,-0.140543z'/%3E%3C/svg%3E");
              background-size: cover;
              border-radius: 0.5rem;
              opacity: 0;
              transition: opacity 250ms ease-in-out;
            }
          }
        }
      }
    }
    & > .earnings-section {
      position: absolute;
      top: 14rem;
      right: 0.5rem;
      //background-color: lightskyblue;
      width: 12.25rem;
      //max-height: 10.5rem;
      box-sizing: border-box;
      padding: 2rem 0 0;
      //border-bottom: 1px solid rgba($brn, 0.5);
      &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        height: 1px;
        background-color: rgba($brn, 0.25);
        transform: scaleX(0.35) translate3d(-0.9rem, 0, 0);
        transition: all 250ms ease-in-out;
        box-shadow: -2px 0 3px rgba($brn, 0.75);
        z-index: 5;
      }
      &:hover {
        //z-index: 1;
        &::after {
          transform: none;
          box-shadow: none;
        }
        & > .earnings {
          max-height: 19.5rem;
        }
      }
      &.hide {
        opacity: 0;
        pointer-events: none;
      }
      & > .title {
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        //left: -15.5rem;
        transform: translate3d(0, -0.25rem, 0);
        //width: 100%;
        font-family: 'Assistant', sans-serif;
        font-size: 1.5rem;
        font-weight: 200;
        color: $brn;
        text-transform: capitalize;
        text-align: center;
        background-color: white;
        padding-top: 0.25rem;
        z-index: 3;
      }
      .earnings {
        //padding-left: 7rem;
        //padding-right: 0.5rem;
        position: relative;
        //max-height: 6.5rem;
        //background-color: #dadada;
        overflow: hidden;
        overflow-y: auto;
        max-height: 6.35rem;
        box-sizing: border-box;
        padding-top: 0.125rem;
        transition: max-height 250ms ease-in-out;
        &::-webkit-scrollbar {
          display: none;
        }
        &:hover {
          & > .earning {
            & > .percent {
              &[perf="pos-small"],
              &[perf="neg-small"],
              &[perf="pos-mid"] {
                .value-unit {
                  opacity: 1;
                  transform: translate3d(-1.5rem, 0, 0);
                }
              }
            }
            & > .eps {
              opacity: 1;
              transform: none;
            }
          }
        }
        .earning {
          display: grid;
          grid-template-columns: 5rem 2.1rem 4.5rem;
          grid-column-gap: 0.25rem;
          white-space: nowrap;
          padding-bottom: 0.25rem;
          transition: all 250ms ease-in-out;
          &.hide {
            display: none;
          }
          & > .date {
            font-family: 'Assistant', sans-serif;
            font-size: 0.7rem;
            text-transform: uppercase;
            white-space: nowrap;
            background-color: white;
            z-index: 1;
            outline: 0.25rem solid white;
          }
          & > .percent {
            position: relative;
            top: -0.25rem;
            text-align: right;
            font-weight: 600;
            &[perf="pos-small"],
            &[perf="neg-small"],
            &[perf="pos-mid"] {
              .value-unit {
                font-weight: 400;
                opacity: 0;
                //transform: rotate3d(0, 1, 1, 90deg);
                transform: translate3d(1.5rem, 0, 0);
                //transform-origin: 130% center;
                transition: all 250ms ease-in-out 500ms;
                //transition: opacity 250ms ease-in-out;
              }
            }
            &.hide {
              opacity: 0 !important;
              pointer-events: none !important;
            }
            & > .value-unit {
              display: inline-block;
              transform: translate3d(-1.5rem, 0, 0);
              & > span.unit {
                font-weight: 400;
                font-size: 0.6rem;
              }
            }
            &[perf="pos-large"],
            &[perf="neg-large"] {
              &::after {
                transform: translate3d(0, -50%, 0) scale(1.3);
              }
            }
            &[perf="pos-small"],
            &[perf="neg-small"] {
              &::after {
                transform: translate3d(0, -50%, 0) scale(0.7);
              }
            }
            &[perf="pos-small"],
            &[perf="pos-mid"],
            &[perf="pos-large"] {
              &::after {
                border-color: orange;
                background-color: transparent;
              }
            }
            &::after {
              position: absolute;
              content: '';
              top: 50%;
              left: 100%;
              margin-left: -1rem;
              transform: translate3d(0, -50%, 0);
              width: 0.75rem;
              height: 0.75rem;
              box-sizing: border-box;
              border: 2px solid $brn;
              border-radius: 50%;
              background-color: $brn;
              z-index: 1;
            }
          }
          & > .eps {
            position: relative;
            top: -0.25rem;
            font-weight: 500;
            text-align: right;
            opacity: 0;
            transition: all 250ms ease-in-out 250ms;
            transform: rotate3d(0, 1, 1, -90deg);
            transform-origin: -30% center;
            &.hide {
              opacity: 0 !important;
              pointer-events: none !important;
            }
          }
          .currency {
            font-family: 'Assistant', sans-serif;
            font-size: 0.7rem;
            text-transform: uppercase;
            white-space: nowrap;
            margin-left: 2px;
            font-weight: 300;
          }
          //border: 2px solid rgba($brn, 0.25);
        }
      }
    }
    & > .industry {
      position: absolute;
      bottom: 0.5rem;
      left: 0.5rem;
    }
    & > .theme {
      position: relative;
      left: -1rem;
      margin-top: 1rem;
      margin-right: 14.5rem;
      font-size: 2.5rem;
      white-space: nowrap;
      max-width: 29rem;
      //width: rem;
      z-index: 2;
      & > .close {
        position: absolute;
        top: -1rem;
        right: -19.25rem;
        transform: scale(0.6);
        color: #ccc;
        &:hover {
          color: black;
        }
      }
    }
    & > .watchlist-link {
      position: absolute;
      top: 2rem;
      right: 0.5rem;
      color: white;
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 0.8rem;
    }
    & > .row {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 0.5rem;
      z-index: 1;
      & > .ticker {
        color: white;
        z-index: 1;
        font-weight: 700;
        transform: translate3d(0, 1px, 0);
        &::before {
          content: 'ticker: ';
          font-weight: 400;
          //color: #ccc;
        }
      }
      & > .performance {
        position: relative;
        text-align: right;
        padding-right: 2rem;
        color: white;
        font-weight: 700;
        transform: translate3d(3.75rem, 1px, 0);
        &::before {
          content: 'performance: ';
          font-weight: 400;
          //color: #ccc;
        }
        & > .arrow {
          position: absolute;
          top: -0.7rem;
          right: -0.5rem;
          transform-origin: center;
          transform: rotate(90deg);
          color: white;
          &.good {
            transform: rotate(-90deg);
          }
          text-align: center;
          font-size: 2rem;
          padding: 0.25rem;
          &::after {
            content: '\00a0';
            position: absolute;
            top: 25%;
            left: 0;
            bottom: 20%;
            right: 0;
            border: 2px solid white;
            border-radius: 0.25rem;
            z-index: -1;
            background-color: orange;
          }
          &:not(.very) {
            & > .bar {
              background-color: orange;
            }
          }
          & > .bar {
            position: absolute;
            top: 30%;
            left: 23%;
            width: 17%;
            bottom: 30%;
          }
        }
      }
    }
    & > .themes {
      margin-top: 1.5rem;
    }
    & > .charts {
      & > .chart {
        position: absolute;
        top: 13.5rem;
        left: 2rem;
        font-family: Assistant, Roboto, sans-serif;
        width: 50%;
        margin-right: 5rem;
        > .bar {
          cursor: pointer;
          position: relative;
          font-size: 0.8rem;
          height: 0.25rem;
          background-color: #ccc;
          margin-bottom: 0.9rem;
          transition: transform 250ms ease-in-out;
          transform-origin: center;
          &.selected {
            background-color: orange;
            font-weight: 700;
            font-size: 1.2rem;
          }
          &:hover {
            //transform: scale(1.1);
            & > .title {
              color: black;
            }
          }
          & > .title {
            position: absolute;
            left: 100%;
            top: 0;
            transform: translate3d(0.5rem, -50%, 0);
            white-space: nowrap;
          }
          & > .toggle-robo {
            top: 0;
            left: 0;
            transform: translate3d(-1.5rem, -50%, 0) scale(0.75);
            transform-origin: left center;
            width: 1.25rem;
            height: 1.25rem;
            z-index: 4;
            background-color: $brn;
            border-radius: 0.25rem;
            overflow: hidden;
            opacity: 0.25;
            transition: opacity 250ms ease-in-out;
            &:hover,
            &.on {
              opacity: 1;
            }
            .eyes {
              position: absolute;
              top: 0.25rem;
              left: 0;
              right: 0;
              display: flex;
              justify-content: space-evenly;
              .eye {
                width: 0.25rem;
                height: 0.25rem;
                background-color: white;
                border: 1px solid #282828;
                border-radius: 50%;
                & + .eye {
                  background-color: orange;
                }
              }
            }
            > .bars {
              position: absolute;
              width: 50%;
              left: 50%;
              > .bar {
                padding-top: 0;
                height: 1px;
                background-color: white;
                margin-top: 1px;
                &.tall {
                  height: 2px;
                }
                &.gap {
                  margin-bottom: 2px;
                }
              }
            }
          }
        }
      }
      & > .ariel-view {
        $cellWidth: 1.75rem;
        $cellPerfWidth: $cellWidth * 4;
        position: absolute;
        top: 14.75rem;
        bottom: 0.25rem;
        transform: translate3d(0, -5rem, 0);
        //overflow-y: auto;
        //overflow-x: visible;
        width: 22%;
        right: 0;
        display: grid;
        grid-template-rows: repeat(300, 1fr);
        $line-height: 0.6rem;
        &::before {
          position: fixed;
          top: -1.5rem;
          left: -5.5rem;
          content: 'performance';
          font-size: 0.8rem;
        }
        &::after {
          position: fixed;
          top: 7.5rem;
          left: -9.5rem;
          content: 'importance';
          font-size: 0.8rem;
          transform: rotate(-90deg);
        }
        .labels {
          position: absolute;
          top: 0;
          right: 0.5rem;
          width: $cellPerfWidth;
          display: grid;
          grid-template-columns: repeat(4, $cellWidth);
          .label {
            cursor: pointer;
            position: relative;
            //&:hover,
            &.on {
              color: black;
            }
            &::after {
              content: attr(rating);
              position: absolute;
              top: -1.7rem;
              left: 50%;
              transform: translate3d(-50%, 0, 0) rotate(45deg);
              font-size: 0.6rem;
              white-space: nowrap;
            }
          }
        }
        .lines {
          //overflow-y: auto;
          position: absolute;
          top: -2.5rem;
          right: -4.5rem;
          bottom: 0;
          width: 25%;
          box-sizing: border-box;
          padding-top: 2.5rem;
          .pager {
            position: absolute;
            top: 100%;
            right: 3.25rem;
            margin-top: 4.4rem;
            display: grid;
            grid-template-columns: repeat(2, 3rem);
            .previous,
            .next {
              cursor: pointer;
              font-size: 0.6rem;
              text-transform: uppercase;
            }
          }
        }
        .line {
          cursor: pointer;
          position: relative;
          left: -5rem;
          height: $line-height;
          margin-bottom: 1.75px;
          //&:first-of-type {
          //  .performance {
          //    .cell {
          //      &::after {
          //        content: attr(rating);
          //        position: absolute;
          //        top: -1.7rem;
          //        left: 50%;
          //        transform: translate3d(-50%, 0, 0) rotate(45deg);
          //        font-size: 0.6rem;
          //        white-space: nowrap;
          //      }
          //    }
          //  }
          //  //transform: translate3d(2rem, 0, 0);
          //}
          &.on {
            & > .bar {
              background-color: $brn;
            }
          }
          .performance {
            position: absolute;
            top: 0;
            //left: -$cellPerfWidth;
            right: 0;
            width: $cellPerfWidth;
            box-sizing: border-box;
            //padding-right: $line-height * 2;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            //grid-column-gap: 1px;
            .cell {
              position: relative;
              top: $line-height / 3.5;
              background-color: #eee;
              height: $line-height / 5;
              &.on {
                top: 0;
                border-top: none;
                border-radius: 2px;
                background-color: orange;
                height: $line-height * 0.8;
                //transform: translate3d(0, $line-height / 2, 0);
              }
            }
          }
          > .bar {
            position: absolute;
            right: $cellPerfWidth + 6rem;
            top: $line-height * 0.1;
            height: $line-height * 0.8;
            background-color: #dadada;
            border-top-left-radius: $line-height / 2;
            border-bottom-left-radius: $line-height / 2;
            &::after {
              content: attr(title);
              position: absolute;
              top: -0.175rem;
              right: -6.1rem;
              width: 6rem;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 0.7rem;
              color: $brn;
            }
            .label {
              display: none;
              position: absolute;
              top: 0;
              left: 5rem;
              white-space: nowrap;
            }
            .performance {
              position: absolute;
              top: 0;
              $cellWidth: 0.5rem;
              $cellPerfWidth: $cellWidth * 4;
              left: -$cellPerfWidth;
              width: $cellPerfWidth;
              box-sizing: border-box;
              padding-right: $line-height * 2;
              display: grid;
              grid-template-columns: repeat(4, 1fr);
              //grid-column-gap: 1px;
              .cell {
                position: relative;
                top: $line-height / 3.5;
                background-color: #eee;
                height: $line-height / 4;
                &.on {
                  top: 0;
                  border-top: none;
                  border-radius: 2px;
                  background-color: orange;
                  height: $line-height;
                  //transform: translate3d(0, $line-height / 2, 0);
                }
              }
            }
          }
        }
      }
      & > .scatter {
        position: absolute;
        left: 0.5rem;
        top: 13.5rem;
        width: 8rem;
        height: 13.5rem;
        //background-color: orange;
        box-sizing: border-box;
        border-radius: 0.5rem;
        //border: 2px solid #eee;
        display: grid;
        grid-template-rows: repeat(2, 1fr);
        grid-row-gap: 0.125rem;
        & > .legends {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 1;
          pointer-events: none;
          transition: opacity 250ms ease-in-out;
          & > .legend {
            position: absolute;
            white-space: nowrap;
            padding: 0.25rem 0.75rem;
            background-color: white;
            border: 1px solid $brn;
            border-radius: 0.25rem;
            box-shadow: 1px 1px 2px rgba($brn, 0.5);
            will-change: transform;
            &.performance {
              top: -0.5rem;
              left: 0;
              //transform: translate3d(0, -200%, 0);
            }
            &.importance {
              top: 0;
              left: 100%;
              //transform: translate3d(-100%, 0, 0);
            }
            span.label {
              color: #bbb;
            }
          }
        }
        & > .matrix {
          display: grid;
          grid-template-columns: repeat(4, 1.75rem);
          //grid-template-columns: repeat(4, 0.75rem);
          grid-template-rows: repeat(4, 1.37rem);
          grid-gap: 0.25rem;
          &:first-of-type {
            & > :first-of-type {
              //background: $brn;
              border-top-left-radius: 0.5rem;
            }
            & > :nth-of-type(4) {
              //background: $brn;
              border-top-right-radius: 0.5rem;
            }
            .area > .fill {
              bottom: 0;
            }
          }
          &:last-of-type {
            & > :last-of-type {
              //background: $brn;
              border-bottom-right-radius: 0.5rem;
            }
            & > :nth-of-type(13) {
              //background: $brn;
              border-bottom-left-radius: 0.5rem;
            }
            .area > .fill {
              top: 0;
            }
          }
          & > .cell {
            position: relative;
            //background: $brn;
            box-sizing: border-box;
            border: 1px solid #ccc;
            padding: 0.25rem;
            padding-top: 0.25rem;
            padding-left: 0.3rem;
            padding-left: 0.3rem;
            //grid-gap: 1px;
            //overflow: hidden;
            background-color: #e5e5e5;
            &:first-of-type,
            &:nth-of-type(2),
            &:nth-of-type(3),
            &:nth-of-type(4) {
              border-top-color: transparent;
            }
            &:first-of-type,
            &:nth-of-type(5),
            &:nth-of-type(9),
            &:nth-of-type(13) {
              border-left-color: transparent;
            }
            &:nth-of-type(4),
            &:nth-of-type(8),
            &:nth-of-type(12),
            &:nth-of-type(16) {
              border-right-color: transparent;
            }
            &:nth-of-type(13),
            &:nth-of-type(14),
            &:nth-of-type(15),
            &:nth-of-type(16) {
              border-bottom-color: transparent;
            }
            .area {
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              .fill {
                max-height: 100%;
                background-color: $brn;
                position: absolute;
                left: 0;
                right: 0;
                height: 50%;
              }
            }
          }
        }
      }
    }
  }
}
</style>
